import { FlexEntity } from "../generated/graphql";

export type TypedFlexEntity<T = any> = FlexEntity & { data: T };

export const isStartingPoint = (entity: TypedFlexEntity<any> | null | undefined) =>
	!!entity?.cases.length &&
	!!entity?.cases.some((cs) => cs.flexEntitiesConnection.edges.some((edge) => edge.node.id === entity!.id && edge.isStartingPoint));
